"use client";

import { useThemeMode } from "@/features/theme/theme-provider";
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from "lucide-react";
import { Toaster as Sonner, type ToasterProps } from "sonner";
const DURATION = 2 * 1000;
const Toaster = ( { ...props }: ToasterProps ) => {
    const { themeMode } = useThemeMode();

    return (
        <>
            <style
                dangerouslySetInnerHTML={{
                    __html: `
                    /* 确保 Toaster 容器在 Body 层级拥有最高优先级 */
                    [data-sonner-toaster] {
                        z-index: 2147483647 !important;
                    }
                    /* 确保吐司本身可点击，但容器不拦截点击 */
                    [data-sonner-toast] {
                        pointer-events: auto !important;
                    }
                `,
                }}
            />

            <Sonner
                theme={themeMode as ToasterProps["theme"]}
                className="toaster group"
                duration={DURATION}
                icons={{
                    success: <CircleCheckIcon className="size-4" />,
                    info: <InfoIcon className="size-4" />,
                    warning: <TriangleAlertIcon className="size-4" />,
                    error: <OctagonXIcon className="size-4" />,
                    loading: <Loader2Icon className="size-4 animate-spin" />,
                }}
                position="bottom-center"
                style={{
                    "--normal-bg": "var(--popover)",
                    "--normal-text": "var(--popover-foreground)",
                    "--normal-border": "var(--border)",
                    "--border-radius": "var(--radius)",
                    bottom: "16px",
                    zIndex: 2147483647,
                } as React.CSSProperties}
                offset="0"
                {...props}
            />
        </>
    );
};

export { Toaster };
